import { render } from "./ItemEmbedFilePreview.vue?vue&type=template&id=f2bf2e56&scoped=true"
import script from "./ItemEmbedFilePreview.vue?vue&type=script&lang=ts"
export * from "./ItemEmbedFilePreview.vue?vue&type=script&lang=ts"

import "./ItemEmbedFilePreview.vue?vue&type=style&index=0&id=f2bf2e56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f2bf2e56"

export default script